import React from 'react';
import styled from 'styled-components';
import { Colors, Fonts } from '@prezi/dragon';
const Title = styled.div.withConfig({
  displayName: "SectionTitle__Title",
  componentId: "sc-1k336rn-0"
})(["color:", ";font-family:", ";font-size:14px;font-weight:600;line-height:20px;letter-spacing:0.25px;margin-bottom:8px;"], Colors.neutral600, Fonts.ralewaySemiBold);
const SectionTitle = ({
  children
}) => {
  return React.createElement(Title, null, children);
};
export default SectionTitle;